import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useTranslation } from '@gem/modules/i18n';

import { usePermissionsRequestsToastPresenter } from './PermissionsRequestsToast.presenter';
import styles from './PermissionsRequestsToast.styles.m.css';

const ANIMATION_TIMEOUT = 250;

const itemTransition = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  exit: styles.exit,
  exitActive: styles.exitActive,
};

export const PermissionsRequestsToast: FC = observer(() => {
  const { t } = useTranslation();
  const presenter = usePermissionsRequestsToastPresenter();

  return (
    <CSSTransition
      in={!!presenter.permissionsRequestsCount}
      classNames={itemTransition}
      timeout={ANIMATION_TIMEOUT}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.event}>
        <div className={styles.eventText}>
          {t('calls_waiting_room_request_permissions_message', {
            0: presenter.permissionsRequestsCount,
          })}
        </div>
        {!presenter.isSidebarVisible ? (
          <button
            className={styles.eventButton}
            onClick={presenter.showRequests}
          >
            {t('common_view')}
          </button>
        ) : null}
      </div>
    </CSSTransition>
  );
});
